import apiRequest from "../../helpers/apiRequest";

export default async (id) => {
    return await apiRequest({
        method: 'delete',
        url: `content/create/note/${id}`,
    })
}
